import { render, staticRenderFns } from "./InsuranceControls.vue?vue&type=template&id=3e87e74e"
import script from "./InsuranceControls.vue?vue&type=script&lang=js"
export * from "./InsuranceControls.vue?vue&type=script&lang=js"
import style0 from "./InsuranceControls.vue?vue&type=style&index=0&id=3e87e74e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports